import React from 'react';
import VippsScratchingHead from './scratching-head.svg';
import MobilepayScratchingHead from './scratching-head-mp.svg';
import { useAppContext } from '../../core/context';
import { Brand, getBrandFromQueryParamOrClaimsOrHost } from '../../core/context/claims';

function ScratchingHead(): React.ReactNode {
  const context = useAppContext();
  const brand = getBrandFromQueryParamOrClaimsOrHost(context.claims);
  return (
    <img
      src={brand === Brand.MOBILEPAY ? MobilepayScratchingHead : VippsScratchingHead}
      alt=""
      aria-hidden="true"
    />
  );
}

export default ScratchingHead;
